export default {
    type: 'PARAGRAPH',
    textMarkupValue: '<p>Replace this text with a survey question</p>',
    fontSize: '20px',
    lineHeight: '20px',
    align: 'center',
};
